import { Box, Image, Text, UnstyledButton } from '@mantine/core';
import { IconPhoto } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ImageLightbox } from '../../components/editor/image-lightbox';

type Props = {
    photos: string[];
    title?: string | null;
    /** Side thumb size in px. */
    size?: number;
};

export const AttractionPhotos: React.FC<Props> = ({ photos, title, size = 72 }) => {
    const { t } = useTranslation();
    const list = photos.filter(Boolean);
    const [opened, setOpened] = useState(false);
    const [index, setIndex] = useState(0);
    const photosKey = list.join('|');

    useEffect(() => {
        setIndex(0);
        setOpened(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [photosKey]);

    const openAt = (i: number) => {
        setIndex(i);
        setOpened(true);
    };

    return (
        <>
            <UnstyledButton
                onClick={() => (list.length ? openAt(0) : undefined)}
                disabled={!list.length}
                style={{
                    position: 'relative',
                    flex: '0 0 auto',
                    width: size,
                    height: size,
                    borderRadius: 10,
                    overflow: 'hidden',
                    border: '1px solid var(--mantine-color-gray-3)',
                    background: 'var(--mantine-color-gray-1)',
                    cursor: list.length ? 'zoom-in' : 'default',
                }}
            >
                {list.length ? (
                    <Image
                        src={list[0]}
                        alt={title || t('components.attractionPhotos.alt')}
                        w={size}
                        h={size}
                        fit='cover'
                    />
                ) : (
                    <Box
                        style={{
                            width: '100%',
                            height: '100%',
                            display: 'grid',
                            placeItems: 'center',
                        }}
                    >
                        <IconPhoto size={20} color='var(--mantine-color-gray-5)' />
                    </Box>
                )}
                {list.length > 1 && (
                    <Text
                        size='10px'
                        fw={700}
                        c='white'
                        style={{
                            position: 'absolute',
                            right: 4,
                            bottom: 4,
                            background: 'rgba(0,0,0,.55)',
                            borderRadius: 4,
                            padding: '1px 5px',
                            lineHeight: 1.4,
                        }}
                    >
                        {list.length}
                    </Text>
                )}
            </UnstyledButton>

            <ImageLightbox
                urls={list}
                index={index}
                opened={opened}
                onClose={() => setOpened(false)}
                onIndexChange={setIndex}
                title={title || t('components.attractionPhotos.defaultTitle')}
            />
        </>
    );
};
